<div class=" d-flex flex-column full-height">
    <app-alert [text]="textAlert" [type]="2" *ngIf="showErrorAlert" (closeAlertEvent)="onErrorAlertClosed()"
        [isForDialog]="true"></app-alert>
    <div class="modal-content">
        <div class="modal-left">
            <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false">
                <mat-tab label="{{ 'upload_your_file' | translate }}">
                    <div class="modal-tab-content">
                        <div class="modal-title">{{ 'upload_your_file' | translate }}</div>
                        <div class="modal-description">{{ 'drag_or_click_to_upload' | translate }}</div>
                        <div class="info-box">
                            <img src="/assets/icons/info-icon.svg" alt="Info Icon" />
                            <span>{{ 'files_saved_for_future' | translate }}<span class="fw-600">{{
                                    'saveFilesForAnotherServices' | translate }}.</span></span>
                        </div>
                        <div class="template_checkbox">
                            <input type="checkbox" id="isTemplateFile" [(ngModel)]="saveAsPermanentFile"
                                name="isTemplateFile" />
                            <label for="isTemplateFile">{{ 'saveFilesForAnotherServices' | translate }}</label>
                        </div>
                        <div class="input-file-container">
                            <label tuiInputFiles>
                                <input #validator="tuiInputFilesValidator" class="input_fileUpload"
                                    [maxFileSize]="50 * 1000 * 1000" accept="application/pdf" [multiple]="true"
                                    [ngModel]="files" (ngModelChange)="onChange($event)" (reject)="onReject($event)"
                                    tuiInputFiles />
                                <ng-template let-dragged>
                                    <div *ngIf="dragged; else base" class="fileupload_content">
                                        <div>
                                            {{ 'dropFilesHere' | translate }}
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <ng-template #base>
                                        <div class="fileupload_content">
                                            <img src="/assets/icons/document-text-gray.svg" alt="Document icon" />
                                            <div>
                                                {{ 'dragOr' | translate }}
                                                <a tuiLink>{{ 'uploadYourFile' | translate }}</a>
                                            </div>
                                        </div>
                                    </ng-template>
                                </ng-template>
                            </label>
                            <tui-files class="tui-space_top-1" [max]="2">
                                <tui-file *ngFor="let file of rejected" state="error"
                                    [file]="(file | tuiFileRejected: validator | async) || file"
                                    (remove)="onRemove(file)" [showSize]="true" />
                                <tui-file *ngFor="let file of files" state="normal" [file]="file"
                                    (remove)="onRemove(file)" [showSize]="true" />
                            </tui-files>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="{{ 'link' | translate }}">
                    <div class="modal-tab-content">
                        <div class="modal-title">{{ 'add_your_link' | translate }}</div>
                        <div class="modal-description">{{ 'add_link_and_name' | translate }}</div>
                        <div class="info-box">
                            <img src="/assets/icons/info-icon.svg" alt="Info Icon" />
                            <span>{{ 'files_saved_for_future' | translate }}<span class="fw-600">{{
                                    'saveLinksForAnotherServices' | translate }}.</span></span>
                        </div>
                        <div class="template_checkbox">
                            <input type="checkbox" id="isTemplateLink" [(ngModel)]="saveAsPermanentLink"
                                name="isTemplateLink" />
                            <label for="isTemplateLink">{{ 'saveLinksForAnotherServices' | translate }}</label>
                        </div>
                        <div>
                            <label class="link_title">{{ 'link_v2' | translate }}</label>
                            <input class="link-input" type="url" placeholder="{{ 'write_your_url' | translate }}"
                                [(ngModel)]="link_url" />
                        </div>
                        <div class="input-file-container">
                            <label class="link_title">{{ 'file_name' | translate }}</label>
                            <input class="link-input" type="text" placeholder="{{ 'file_name' | translate }}"
                                [(ngModel)]="link_name" />
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="modal-right">
            <div class="modal-title">{{ 'add_saved_files' | translate }}</div>
            <div class="modal-description">{{ 'select_files_to_add' | translate }}:</div>
            <div class="search-bar">
                <div>
                    <img src="/assets/icons/searchIcon.svg" alt="Search Icon" class="search-icon" />
                    <input #searchInput (input)="onSearchChange()" type="text"
                        placeholder="{{ 'search_file' | translate }}" class="search-bar-input" />
                    <img src="/assets/icons/close-modal.svg" alt="Close icon" class="close-icon"
                        (click)="clearFilter()" />
                </div>
                <div class="file-list">
                    <div *ngFor="let file of documents" class="file-item"
                        [ngClass]="{'selected': file.checked, 'blocked': isDocumentBlocked(file)}"
                        (click)="toggleDocumentCheck(file)">
                        <div><img *ngIf="file.type === 1" src="../../../../../assets/icons/document-text.svg" />
                            <img *ngIf="file.type === 2" src="../../../../../assets/icons/link.svg" />
                        </div>
                        <div class="file-details">
                            <div>{{ file.name }}</div>
                            <div *ngIf="file.type === 2"><span class="file-meta">{{ 'url' | translate }}: {{ file.link
                                    }}</span></div>
                            <div *ngIf="file.type === 1"><span class="file-meta">{{ 'uploaded' | translate }}: {{
                                    file.uploadedDate }}</span>
                            </div>
                        </div>
                        <div class="file-size" *ngIf="file.type === 1">{{ file.fileSize }}</div>
                        <div class="check"><input type="checkbox" [checked]="file.checked"
                                style="pointer-events: none;" /></div>
                        <div class="delete-saved-icon">
                            <img (click)="deleteSavedFile(file, $event)"
                                src="/assets/icons/datatable-trash-red.svg" alt="Delete icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="button-container">
            <div (click)="cancel()" class="button cancel-button">{{ 'cancel_operation' | translate }}</div>
        </div>
        <div class="button-container">
            <div (click)="submit()" class="button submit-button" [ngClass]="{'disabled': disableButton()}">{{
                'upload_files' | translate }}</div>
        </div>
    </div>
</div>